<template>
  <div id="app">
    <main class="app-main">
      <router-view />
    </main>
    <footer class="app-footer">
      <div class="app-footer-inner">
        <div class="app-footer-inner-right">
          <div class="app-footer-inner-right-logo">
            <img src="./assets/icon-logo.png" alt="">
            <p>圣诉，放心找律师的大平台</p>
          </div>
          <div class="line"></div>
          <div class="app-footer-inner-right-text">
            <p>北京新橙长科技有限公司</p>
            <p>北京市朝阳区礼安门A座</p>
            <p>电话：185 1825 8334</p>
            <p>服务热线：400-8620-371</p>
          </div>
        </div>
        <div class="app-footer-inner-logo">
          <img src="./assets/pic-right.png" alt="">
          <p>扫码联系圣诉律师</p>
        </div>
      </div>
      <div class="copyright">
        <span>Copyright © 北京新橙长科技有限公司. All rights reserved.</span>
        <a href="https://beian.miit.gov.cn" target="_blank">京ICP备19014217号-5</a>
      </div>
    </footer>
  </div>
</template>
<script>
  import store from './store'
  const NAVIGATIONS = [
    { name: 'home', txt: '首页' },
    { name: 'home-service', txt: '圣诉服务' },
    { name: 'home-lawyer', txt: '圣诉律师' },
    { name: 'home-article', txt: '圣诉文章' },
    { name: 'home-advantage', txt: '圣诉优势' },
    { name: 'join-us', txt: '加入圣诉' }
  ]
  export default {
    name: 'app',
    store: store,
    data () {
      return {
        navData: NAVIGATIONS,
        activeIndex: NAVIGATIONS.findIndex(navigate => {
          return navigate.name === this.$route.name
        })
      }
    },
    methods: {
      // 路由跳转
      navigatorRoute (path) {
        let router = this.$router.resolve({
          name: path
        })
        if (path !== this.$route.name) {
          window.open(router.href)
        }
      }
    }
  }
</script>

<style lang="stylus">
  @import "styles/var.styl"
  @import "styles/reset.styl"
  @import "styles/common.styl"
  html, body {
    width: 100%;
    height: 100%;
    background: #fff !important
  }
  #app{
    width: 100%;
    height 100%
    font-size .14rem
    font-family: PingFangSC;
    diplay flex
    flex-direction column
  }
  .app-main {
    flex 1
    overflow auto
  }
  .app-footer {
    width: 100%
    background: #333
    padding .32rem 0 0
    .copyright {
      margin-top: 20px
      border-top: 1px solid #565656
      height: 50px
      line-height: 50px
      text-align: center
      color: #b1b1b1
      a {
        color: #b1b1b1
        margin-left: 20px
      }
    }
    &-inner {
      width: 9.6rem
      height: 1.08rem
      margin: 0 auto
      display flex
      align-items center
      justify-content space-between
      &-right {
        display flex
        &-logo {
          margin-right .32rem
          img {
            width: 1.74rem
            height: .6rem
            margin-bottom .12rem
          }
          font-size: .16rem
          font-weight: 500
          color #fff
        }
        &-text {
          font-weight: 300
          color: #b1b1b1;
          line-height .27rem
          margin-left .31rem
        }
        .line {
          height: 1.08rem
          width: 1px;
          background-color: #565656;
        }
      }
      &-logo {
        text-align center
        img {
          width: .8rem
          height: .8rem
        }
        p {
          font-size: 12px;
          font-weight: 300;
          color: #b1b1b1;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue